const s = {
  name: "PosInterfacesShopperExperience",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,0H0v19h13V0z M2,17V2h9v15H2z"/>
		<path class="st0" d="M15,14c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3V14z M18,13
			c-0.6,0-1,0.4-1,1v3h6v-3c0-0.6-0.4-1-1-1H18z M17,22c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-3h-6V22z"/>
		<path class="st0" d="M17,29v-2h6v2H17z"/>
		<path class="st0" d="M15,0h25v9H15V0z M17,2v5h21V2H17z"/>
		<path class="st0" d="M25,31H0v9h25V31z M2,38v-5h21v5H2z"/>
		<path class="st0" d="M0,21v8h13v-8H0z M2,23h9v4H2V23z"/>
		<path class="st0" d="M40,11H27v29h13V11z M29,38V13h9v25H29z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosInterfacesShopperExperience
};
